
import React from "react";

interface Props {
  title:      string;
  message:    string;
  confirmLabel?: string;   // default "Delete"
  cancelLabel?:  string;   // default "Cancel"
  danger?:    boolean;     // red confirm button (default true)
  onConfirm:  () => void;
  onCancel:   () => void;
}

const ConfirmModal: React.FC<Props> = ({
  title, message,
  confirmLabel = "Delete",
  cancelLabel  = "Cancel",
  danger       = true,
  onConfirm, onCancel,
}) => (
  <div className="modal-overlay" onClick={onCancel}>
    <div className="confirm-box" onClick={e => e.stopPropagation()}>

      <div className="confirm-icon">
        {danger ? "⚠" : "?"}
      </div>

      <div className="confirm-title">{title}</div>
      <div className="confirm-message">{message}</div>

      <div className="confirm-actions">
        <button className="confirm-btn confirm-btn--cancel" onClick={onCancel}>
          {cancelLabel}
        </button>
        <button
          className={`confirm-btn ${danger ? "confirm-btn--danger" : "confirm-btn--primary"}`}
          onClick={onConfirm}
          autoFocus
        >
          {confirmLabel}
        </button>
      </div>

    </div>
  </div>
);

export default ConfirmModal;